import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* initDeviceGroupsSaga() {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    yield put(actions.initDeviceGroupsStart());
    var path = '/deviceGroups';
    var bod = {
      rMac: rMac,
      bToken: token,
      sessionToken: sessionToken
    };

    try {
      const response = yield axios.post(path, bod)

      yield put(actions.setDeviceGroups(response.data.deviceGroups));
    } catch (error) {
      yield put(actions.fetchDeviceGroupsFailed());
      yield console.error(`FAILURE WHILE FETCHING '.../deviceGroups', ${error}`)

    }
  }
}

export function* createDeviceGroupSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    yield put(actions.createDeviceGroupStart());
    var path = '/createDeviceGroup';
    var body = {
      rMac: rMac,
      bToken: token,
      sessionToken: sessionToken,
      ...action.deviceGroup
    };
    try {
      const response = yield axios.post(
        path,
        body
      )

      if (response.data.status === 200) {
        yield put(actions.createDeviceGroupSuccess());
        yield put(actions.initDeviceGroups());
        yield put(actions.initDevices(action));
      } else {
        yield put(actions.createDeviceGroupFailed());
      }

    } catch (error) {
      yield put(actions.createDeviceGroupFailed());
    }
  } else {
    console.error('NO TOKEN')
  }
}

export function* getDevicesFromGroupSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {

    yield put(actions.getDevicesFromGroupStart());
    var path = '/getDevicesfromGroup';
    var body = {
      rMac: rMac,
      bToken: token,
      sessionToken: sessionToken,
      ...action.deviceGroup
    };
    try {
      const response = yield axios.post(path, body)

      // console.log('GETDEVICESFROMGROUP', response.data)
      //yield put(actions.setDeviceGroups(response.data.deviceGroups));
      //  yield put(actions.setDevicesByEquipment(response.data, action.selectedEquipment));
    } catch (error) {
      // console.error('THERE IS ERR IN GETDEVICESFROMGROUP', error)
      yield put(actions.getDevicesFromGroupFailed());
    }
  } else {
    //console.log('NO TOKEN')
  }
}

export function* deleteGroups(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const reqBody = {
        rMac,
        bToken: token,
        deviceGroupId: action.deviceGroupId,
        sessionToken
      }
      const response = yield axios.post(
        '/deleteDeviceGroups',
        reqBody
      );
      if (response.data.status === 200) {
        yield put(actions.deleteGroupSucess());
        yield put(actions.initDeviceGroups());
        yield put(actions.initDevices(action));
      } else {
        // console.log('FAILED DEVICES')
        yield put(actions.deleteGroupFailed());
      }
    } catch (error) {
      // console.error('THERES CHANGE DEVICES ERROR', error)
      yield put(actions.deleteGroupFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.deleteGroupFailed());

  }

}

export function* unassignedDeviceGroups(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const reqBody = {
        rMac,
        bToken: token,
        deviceGroupId: action.deviceGroupId,
        deviceMacs: action.deviceMacs,
        sessionToken
      }
      const response = yield axios.post(
        '/unAssignedDeviceGroups',
        reqBody
      );
      if (response.data.status === 200) {
        yield put(actions.unassignDeviceGroupSucess());
        yield put(actions.initDeviceGroups());
        yield put(actions.initDevices(action));
      } else {
        // console.log('FAILED DEVICES')
        yield put(actions.unassignDeviceGroupFailed());
      }


    } catch (error) {
      // console.error('THERES CHANGE DEVICES ERROR', error)
      yield put(actions.unassignDeviceGroupFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.unassignDeviceGroupFailed());

  }

}

export function* changeDeviceGroupDetailsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      let path = '/changeDeviceGroupDetails';
      let body;
      if (action.pathType === 'assignDevice') {
        body = {
          rMac: rMac,
          bToken: token,
          deviceGroupId: action.deviceGroupId,
          nickname: action.deviceGroupName,
          primaryDevice: action.groupPrimaryDevice,
          assignedDevices: action.groupAssignedDevices,
          sessionToken: sessionToken,
          apiType: 'assignDevice'
        }
      } else if (action.pathType === 'moveDevice') {
        body = {
          rMac: rMac,
          bToken: token,
          deviceGroupId: action.deviceGroupId,
          assignedDevices: action.groupAssignedDevices,
          sessionToken: sessionToken,
          apiType: 'moveDevice'
        }
      } else if (action.pathType === 'editDeviceDetails') {
        body = {
          rMac: rMac,
          bToken: token,
          deviceGroupId: action.deviceGroupId,
          nickname: action.deviceGroupName,
          imageId: action.deviceGroupIcon,
          sessionToken: sessionToken,
          apiType: 'editDeviceDetails'
        }
      }
      // console.log('body of the request',body);
      const response = yield axios.post(
        path,
        body
      );
      // console.log("came to response",response)

      if (response.data.status === 200) {
        yield put(actions.initDeviceGroups({ action }));
        yield put(actions.initDevices(action));
        yield put(actions.changeDevicesGroupSuccess());
      } else {
        // console.log('THERES CHANGE GROUP DEVICE NAME OR ICON ERROR')
        yield put(actions.changeDevicesGroupFailed(action));
      }


    } catch (error) {
      // console.error('THERES CHANGE DEVICE GROUP NAME OR ICON ERROR', error)
      yield put(actions.changeDevicesGroupFailed(action));
    }
  } else {
    console.log('NO TOKEN')
    yield put(actions.changeDevicesGroupFailed(action));

  }

}

export function* deleteGroupPauseScheduleSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    const params = {
      routerMac: rMac,
      deviceGroupId: action.deviceGroupId,
      templateId: action.templateId,
    }

    try {
      const response = yield axios.delete('/DeviceGroup/pauseSchedule', { params })
      // yield console.log('CHECK OUT MY RESPONSE', response.data);
      // yield console.log('CHECK OUT MY ACTION', action)
      yield put(actions.initDeviceGroups({ action }));
      yield put(actions.initDevices(action));
      yield put(actions.pauseDeviceGroupSuccess());
    } catch (e) {
      yield put(actions.pauseDeviceGroupFailed(e));
    }
  }
}

export function* createPauseScheduleSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    const body = {
      routerMac: rMac,
      bToken: token,
      sessionToken: sessionToken,
      deviceGroupId: action.deviceGroupId,
      templateId: action.templateId,
      template: action.template,
    }

    try {
      const response = yield axios.put('/DeviceGroup/pauseSchedule', body)
      // yield console.log('CHECK OUT MY RESPONSE', response.data);
      // yield console.log('CHECK OUT MY ACTION', action)
      yield put(actions.initDeviceGroups({ action }));
      yield put(actions.initDevices(action));
      yield put(actions.pauseDeviceGroupSuccess());
    } catch (e) {
      yield put(actions.pauseDeviceGroupFailed(e));
    }
  }
}

// TODO: consolidate `pauseDeviceGroupSaga` and `freezeDeviceGroup` into one saga

export function* pauseDeviceGroupSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      let path = '/changePauseDeviceGroup';
      let body;
      if (action.template && action.template.GroupPauseScheduleForm) {

        if (action.action === 'put') {
          body = {
            rMac: rMac,
            bToken: token,
            deviceGroupId: action.deviceGroupId,
            templateId: action.templateId,
            action: action.action,
            sessionToken: sessionToken,
            GroupPauseScheduleForm: action.template.GroupPauseScheduleForm,
            deleteAllExceptSuspend: false,
            enable: action.template.schedulePause,
            name: action.template.name,
            schedules: action.template.schedules,
            isSchedule: !!action.isSchedule && action.isSchedule === true ? true : false,
          }
        } else if (action.action === 'delete') {
          body = {
            rMac: rMac,
            bToken: token,
            GroupPauseScheduleForm: action.template.GroupPauseScheduleForm,
            deviceGroupId: action.deviceGroupId,
            templateId: action.templateId,
            action: action.action,
            sessionToken: sessionToken
          }
        }
      } else {
        body = {
          rMac: rMac,
          bToken: token,
          deviceGroupId: action.deviceGroupId,
          templateId: action.templateId,
          action: action.action,
          sessionToken: sessionToken
        }
      }



      // console.log('pauseDeviceGroupSaga body', body);
      // return;
      const response = yield axios.post(
        path,
        body
      );
      // console.log("came to response",response)

      if (response.data.status === 200) {
        // yield console.log(action)
        yield put(actions.initDeviceGroups({ action }));
        yield put(actions.initDevices(action));
        yield put(actions.pauseDeviceGroupSuccess());
      } else {
        // console.log('THERES CHANGE GROUP DEVICE NAME OR ICON ERROR')
        yield put(actions.pauseDeviceGroupFailed(action));
      }


    } catch (error) {
      yield put(actions.pauseDeviceGroupFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.pauseDeviceGroupFailed(action));
  }
}

export function* freezeDeviceGroup(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const response = yield axios.post(
        '/changeGroupFreeze',
        {
          rMac: rMac,
          bToken: token,
          deviceGroupId: action.deviceGroupId,
          sessionToken: sessionToken
        }
      )

      if (response.data.status === 200) {
        yield put(actions.initDeviceGroups({ action }));
        yield put(actions.initDevices(action));
        yield put(actions.freezeDevicesGroupSuccess());
      } else {
        // console.log('THERES CHANGE GROUP DEVICE NAME OR ICON ERROR')
        yield put(actions.freezeDevicesGroupFailed(action));
      }

    } catch (error) {
      console.error('CHANGE FREEZE ERROR', error)
      yield put(actions.freezeDevicesGroupFailed(action));
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.freezeDevicesGroupFailed(action));

  }

}
